import { render } from "./newDetails.vue?vue&type=template&id=4ddd9b6a"
import script from "./newDetails.vue?vue&type=script&lang=js"
export * from "./newDetails.vue?vue&type=script&lang=js"

import "./newDetails.vue?vue&type=style&index=0&id=4ddd9b6a&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__